import { makeStyles } from "@mui/styles";

const useStyle = makeStyles((theme) => ({

  box: {
    borderRadius: 5,
    paddingLeft: 8,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      borderRadius: 5,
    paddingLeft:22,
    paddingRight:30,
    width: "100%",
    },
  },
}));

export default useStyle;
